import React from 'react'

export default function Map() {
  return (
    <div className='Container-2'>
      <iframe className='Map' src='https://map.mclive.xyz' title='Map' width={800} height={600} allowFullScreen={false} />
    </div>
  )
}
